import { CompanyListItem } from './company.model';

export interface DebtorListItem extends CompanyListItem {
  statusName: DebtorStatus;
  reverse: boolean;
}

export enum DebtorStatus {
  PENDING_VALIDATION = 'PENDING_VALIDATION',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  DEACTIVATED = 'DEACTIVATED',
  PRE_APPROVED = 'PRE_APPROVED',

  DANGEROUS = 'DANGEROUS',
  TO_REVIEW = 'TO_REVIEW',
  NOT_RATED = 'NOT_RATED',
}

export enum DebtorFakeStatus {
  PENDING_VALIDATION = 'PENDING_VALIDATION',
  REJECTED = 'REJECTED',
  DEACTIVATED = 'DEACTIVATED',
  PRE_APPROVED = 'PRE_APPROVED',
  NOT_RATED = 'NOT_RATED',
}
